<h2 mat-dialog-title>Завершение {{testType === 'POLL' ? 'опроса' : 'тестирования'}}</h2>
<div mat-dialog-content>
  <p>Вы действительно хотите завершить выполнение {{testType === 'POLL' ? 'опроса' : 'теста'}}?</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Отмена</button>
  <button mat-button color="warn"
          cdkFocusInitial
          (click)="onSubmit()">Завершить
  </button>
</div>
